<template>
  <div class="basic-checkbox">
    <input
      :id="name"
      type="checkbox"
      @input="execCheck"
      :checked="checked"
      :disabled="disabled"
      @change="checkBoxClick()"
    />
    <label :for="name" :style="checkBoxSize" :class="bindCheckClass"></label>
    <label :for="name" :class="bindFontClass">
      <slot />
    </label>
  </div>
</template>

<script>
export default {
  props: {
    checked: {
      type: Boolean,
      required: true,
      default: false,
    },
    name: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      default: '22px',
    },
    fontClasses: {
      type: Array,
      default() {
        return []
      },
    },
    right: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
    },
  },
  computed: {
    checkBoxSize() {
      return {
        width: this.size,
        height: this.size,
      }
    },
    defaultCheckClass() {
      const d = ['checkmark']
      if (this.checked) {
        d.push('checked')
      }
      return d
    },
    bindCheckClass() {
      const d = [...this.defaultCheckClass]
      if (this.right === false) {
        d.push('mr-2')
      }
      return d
    },
    bindFontClass() {
      const d = ['font--m-5']
      return [...d, ...this.fontClasses]
    },
  },
  methods: {
    execCheck(e) {
      this.$emit('update:checked', e.target.checked)
    },
    checkBoxClick() {
      this.$emit('change')
    },
  },
}
</script>

<style lang="scss" scoped>
.basic-checkbox {
  cursor: pointer;
}

.basic-checkbox .checkmark:after {
  left: 8px;
  top: 4px;
  width: 7px;
  height: 10px;
}
</style>
